module.exports = __webpack_public_path__ + "img/besiness-feature-scope.f96e91cb.png";